export default {
    // -------------------------------- Methods ---------------------------------------
    props:{
        highlightCoversOnMouseOver: {type: Boolean, default: false},
        highlightBuildingsOnMouseOver: {type: Boolean, default: false},
        highlightFloorsOnMouseOver: {type: Boolean, default: false},
        highlightUnitsOnMouseOver: {type: Boolean, default: false},
    },
    methods:{
        initEventsListeners(){
            this.mapViewer.viewApi.register_event("cover_clicked", this.onCoverClick );
            this.mapViewer.viewApi.register_event("building_clicked", this.onBuildingClick );
            this.mapViewer.viewApi.register_event("floor_clicked", this.onFloorClick );
            this.mapViewer.viewApi.register_event("store_clicked", this.onUnitClick );
            this.mapViewer.viewApi.register_event("unit_clicked", this.onUnitClick );
            // ViewApi.register_event("on_zoom_out", this.on_zoom_out);

            if (this.$listeners.coverMouseOver || this.highlightCoversOnMouseOver)
                this.mapViewer.viewApi.register_event("mouse_over_cover", this.onCoverMouseOver)

            if(this.$listeners.buildingMouseOver || this.highlightBuildingsOnMouseOver)
                this.mapViewer.viewApi.register_event("mouse_over_building", this.onBuildingMouseOver )

            if(this.$listeners.floorMouseOver || this.highlightFloorsOnMouseOver)
                this.mapViewer.viewApi.register_event("mouse_over_floor", this.onFloorMouseOver)

            if(this.$listeners.unitMouseOver || this.highlightUnitsOnMouseOver)
                this.mapViewer.viewApi.register_event("mouse_over_unit", this.onUnitMouseOver )
        },
        deactivateEventsListeners(){
            this.mapViewer.viewApi.deregister_event("cover_clicked", this.onCoverClick)
            this.mapViewer.viewApi.deregister_event("building_clicked", this.onBuildingClick);
            this.mapViewer.viewApi.deregister_event("floor_clicked", this.onFloorClick);
            this.mapViewer.viewApi.deregister_event("store_clicked", this.onUnitClick);
            this.mapViewer.viewApi.deregister_event("unit_clicked", this.onUnitClick);

            if(this.$listeners.coverMouseOver || this.highlightCoversOnMouseOver){
                this.mapViewer.viewApi.deregister_event("mouse_over_cover", this.onCoverMouseOver )
                this.mapViewer.viewApi.set_building_cover_focus_color('')
            }

            if(this.$listeners.buildingMouseOver || this.highlightBuildingsOnMouseOver){
                this.mapViewer.viewApi.deregister_event("mouse_over_building", this.onBuildingMouseOver )
                this.mapViewer.viewApi.set_building_focus_color('')
            }
            if(this.$listeners.floorMouseOver || this.highlightFloorsOnMouseOver){
                this.mapViewer.viewApi.deregister_event("mouse_over_floor", this.onFloorMouseOver )
                this.mapViewer.viewApi.set_floor_focus_color('')
            }

            if(this.$listeners.unitMouseOver || this.highlightUnitsOnMouseOver){
                this.mapViewer.viewApi.deregister_event("mouse_over_unit", this.onUnitMouseOver )
            }

        },
        // ----------------------------------- Click ------------------------------------
        onCoverClick(value){
            this.isActive && this.$emit('coverClick', value && value.building_id)
        },
        onBuildingClick(value){
            this.isActive && this.$emit('buildingClick', value && value.building_id)
        },
        onFloorClick(value){
            this.isActive && this.$emit('floorClick', value && value.id)
        },
        onUnitClick(value){
            this.isActive && this.$emit('unitClick', value && value.id)
        },

        // ----------------------------------- Hover ------------------------------------
        onCoverMouseOver(value){
            this.isActive && this.$emit('coverMouseOver', value && value.building_id)
            if(this.highlightCoversOnMouseOver)
                this.mapViewer.viewApi.set_building_cover_focus_color(value && value.building_id || '')
        },
        onBuildingMouseOver(value){
            this.isActive && this.$emit('buildingMouseOver', value && value.building_id)
            if(this.highlightBuildingsOnMouseOver)
                this.mapViewer.viewApi.set_building_focus_color(value && value.building_id || '')
        },
        onFloorMouseOver(value){
            this.isActive && this.$emit('floorMouseOver', value && value.floor_id)
            if(this.highlightFloorsOnMouseOver)
                this.mapViewer.viewApi.set_floor_focus_color(value && value.floor_id || '')
        },
        onUnitMouseOver(value){
            const val = value && value.unit_id
            this.isActive && this.$emit('unitMouseOver', val)
            if(this.highlightUnitsOnMouseOver)
                this.mapViewer.viewApi.set_unit_focus_color &&
                this.mapViewer.viewApi.set_unit_focus_color(value && value.unit_id || '')
        },
    },

    watch:{
        '$listeners':{
            handler(){
                this.hasCoverClickEvent = this.$listeners.coverClick ? true : false
                this.hasBuildingClickEvent = this.$listeners.buildingClick ? true : false
                this.hasFloorClickEvent = this.$listeners.floorClick ? true : false
                this.hasUnitClickEvent = this.$listeners.unitClick ? true : false
            },
            immediate: true

        },
    },
    mounted(){
        this.initEventsListeners()
    },
    beforeDestroy(){
        this.deactivateEventsListeners()
    }
}
